export default __webpack_public_path__ + "static/media/hero-img.981f5aa9.png";